import axios from "axios";
import { API_BASE_URL, API_BASE_URL1 } from "../Services/baseApiUrl";
import axiosInstance from "../../Hooks/axoisInstance";

const getToken = () => {
  return localStorage.getItem("token");
};

export const AllCollectionPointDetails = async ({ zoneId, circleId, wardId, shift, collectionPointCode, CollectionPointFilter, isActive, CollectionPointTypeId, routeCode,
  routeName, }) => {
  try {
    // Construct the query parameters
    const params = new URLSearchParams();

    if (zoneId) params.append('zoneId', zoneId);
    if (circleId) params.append('circleId', circleId);
    if (wardId) params.append('wardId', wardId);
    if (shift) params.append('ShiftId', shift);
    if (collectionPointCode) params.append('collectionPointCode', collectionPointCode)
    if (CollectionPointFilter) params.append('CollectionPointFilter', CollectionPointFilter)
    if (CollectionPointTypeId) params.append('CollectionPointTypeId', CollectionPointTypeId)
    if (routeCode) params.append('routeCode', routeCode);
    if (routeName) params.append('routeName', routeName);

    if (isActive !== null && isActive !== undefined) {
      params.append('isActive', isActive === true ? "true" : "false");
    } else {
      params.append('isActive', "true"); // Default to true if isActive is not provided
    }
    // Send the GET request with query parameters
    const response = await axiosInstance.get(`${API_BASE_URL1}Routes/GetAllCollectionPoints?${params.toString()}`, {
      headers: {
        Authorization: `Bearer ${getToken()}`
      }
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const GetCollectionPointsByZoneCircleShift = async (collectionPointDetails) => {
  try {
    const response = await axiosInstance.post(API_BASE_URL1 + `collection_point/get`, collectionPointDetails,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`
        },

      });
    return response;
  } catch (error) {
    throw error;
  }
};

// export const AddCollectionPointsDetails = async (formData) => {
//   try {
//     const formData = new FormData();

//     // Convert payload to form data
//     for (const key in payload) {
//       formData.append(key, payload[key]);
//     }

//     const response = await axios.post(API_BASE_URL1 + `Routes/AddCollectionPoint`, formData, {
//       headers: {
//         Authorization: `Bearer ${getToken()}`,
//         "Content-Type": "multipart/form-data",
//       },
//     });

//     return response;
//   } catch (error) {
//     throw error;
//   }
// };

export const AddCollectionPointsDetails = async (collectionPointData) => {
  try {
    const response = await axiosInstance.post(API_BASE_URL1 + `Routes/AddCollectionPoint`, collectionPointData,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
          "Content-Type": "multipart/form-data",
        },
      })
    return response;
  } catch (error) {
    throw error;

  }
};




export const UpdateCollectionPointsDetails = async (collectionPointData) => {
  try {
    const response = await axios.put(API_BASE_URL1 + `Routes/UpdateCollectionPoint`, collectionPointData,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
          "Content-Type": "multipart/form-data",
        },

      });

    // const successMessage = 'Collection Points Updated Successfully'
    // toast.success(successMessage, {
    //     position: 'top-right',
    //     autoClose: 3000,
    //     hideProgressBar: false,
    //     closeOnClick: true,
    //     pauseOnHover: true,
    //     draggable: true,
    //     progress: undefined,
    // })

    // if (!response.ok) {
    //   throw new Error("Failed to Update Collection Points");
    // }

    return response;
  } catch (error) {
    throw error;

  }
};


export const getCollectionPointsById = async (id) => {
  try {
    const response = await axiosInstance.get(API_BASE_URL1 + `collection_point/getById/${id}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`
        },

      });
    // console.log(response, 'response')
    return response;
  } catch (error) {
    throw error

  }
};

export const GetAllCollectionPointsZone = async (requestData) => {
  try {
    const { zoneId } = requestData;
    const response = await axiosInstance.get(API_BASE_URL1 + `Routes/GetAllCollectionPoints?zoneId=${zoneId}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`
        }
      }
    );
    return response;
  } catch (error) {
    throw error
  }
};

export const GetAllCollectionPointsZoneCircle = async (requestData) => {
  try {
    const { zoneId, circleId } = requestData;
    const response = await axiosInstance.get(API_BASE_URL1 + `Routes/GetAllCollectionPoints?zoneId=${zoneId}&circleId=${circleId}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`
        }
      }
    );
    return response;
  } catch (error) {
    throw error
  }
};

export const AllCollectionPointTypeDetails = async () => {
  try {
    const response = await axiosInstance.get(API_BASE_URL1 + `MasterDetails/GetAllCollectionPointType`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`
        }
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};